import { ComponentProps, ReactNode } from 'react';

import GenericGitIcon from '@/assets/ico/git.svg?c';
import Github from '@/assets/ico/vendor/github.svg?c';
import Gitlab from '@/assets/ico/vendor/gitlab.svg?c';
import Bitbucket from '@/assets/ico/vendor/bitbucket.svg?c';
import Azure from '@/assets/ico/vendor/azure.svg?c';
import Gitea from '@/assets/ico/vendor/gitea.svg?c';
import { SourcesProvider } from '@/react/portainer/generated-api/portainer/types.gen';

import { Icon } from '@@/Icon';

const iconMap: Record<SourcesProvider, ReactNode> = {
  [SourcesProvider.PROVIDER_CUSTOM]: GenericGitIcon,
  [SourcesProvider.PROVIDER_GIT_HUB]: Github,
  [SourcesProvider.PROVIDER_GIT_LAB]: Gitlab,
  [SourcesProvider.PROVIDER_BITBUCKET_CLOUD]: Bitbucket,
  [SourcesProvider.PROVIDER_BITBUCKET_DATA_CENTER]: Bitbucket,
  [SourcesProvider.PROVIDER_AZURE_DEV_OPS]: Azure,
  [SourcesProvider.PROVIDER_GITEA_FORGEJO]: Gitea,
};

export function GitIcon({
  provider = SourcesProvider.PROVIDER_CUSTOM,
  ...props
}: { provider?: SourcesProvider } & Omit<ComponentProps<typeof Icon>, 'icon'>) {
  return (
    <Icon
      icon={iconMap[provider]}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
